export default __webpack_public_path__ + "static/media/inuneko_logo_s@3x.1db85434.png";